export default "/images/home-recruit.webp?524b7d62410fbf3a3689f00c7617217a";